import { Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper, TimeHelper } from "helpers";
import {
  IPackingLogByQR,
  IPaginateApiResponse,
  IPaginationRequest,
} from "model";
import { I18nTranslator, translations } from "utils/i18n";

const PackingLog = (props: {
  loading: boolean;
  result: IPaginateApiResponse<IPackingLogByQR[]>;
  request: IPaginationRequest;
  onChangePage(pageNumber: number): void;
  onPageSizeChange(pageSize: number): void;
  onSearch(searchText: string): void;
}) => {
  const { loading, result, onChangePage, onPageSizeChange, onSearch } = props;

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "packagingDate",
      headerName: I18nTranslator(translations.report.packagingDate),
      size: "small",
      sortable: true,
      renderCell: ({ value }) => {
        return (
          <Typography>
            {value ? TimeHelper.formatDate(value, "DD/MM/YYYY") : ""}
          </Typography>
        );
      },
    }),
    TableHelper.createCell({
      field: "device",
      headerName: I18nTranslator(translations.report.device),
      size: "small",
    }),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.report.productLot),
      size: "small",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "palletCode",
      headerName: I18nTranslator(translations.report.palletCode),
      size: "small",
      sortable: true,
    }),

    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.report.productCode),
      size: "small",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "productName",
      headerName: I18nTranslator(translations.report.productName),
      size: "full",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productCodeOld",
      headerName: I18nTranslator(translations.report.productCodeOld),
      size: "small",
    }),
    TableHelper.createCell({
      field: "packingType",
      headerName: I18nTranslator(translations.report.packingType),
      size: "small",
    }),
    TableHelper.createCell({
      field: "packageSize",
      headerName: I18nTranslator(translations.report.packSize),
      size: 120,
      align: "right",
    }),

    TableHelper.createCell({
      field: "poNumber",
      headerName: I18nTranslator(translations.report.poNumber),
      size: "small",
    }),
    TableHelper.createCell({
      field: "manufacturingDate",
      headerName: I18nTranslator(translations.report.manufacturingDate),
      size: "small",
      renderCell: ({ value }) => {
        return (
          <Typography>
            {value ? TimeHelper.formatDate(value, "DD/MM/YYYY") : ""}
          </Typography>
        );
      },
    }),
    TableHelper.createCell({
      field: "expiryDate",
      headerName: I18nTranslator(translations.report.expiryDate),
      size: "small",
      renderCell: ({ value }) => {
        return (
          <Typography>
            {value ? TimeHelper.formatDate(value, "DD/MM/YYYY") : ""}
          </Typography>
        );
      },
    }),
    TableHelper.createCell({
      field: "packagingUser",
      headerName: I18nTranslator(translations.report.packagedBy),
      size: "medium",
    }),
    TableHelper.createCell({
      field: "encryptedBarcode",
      headerName: I18nTranslator(translations.report.encryptedQrCode),
      size: "medium",
    }),
    TableHelper.createCell({
      field: "cartonCode",
      headerName: I18nTranslator(translations.report.cartonCode),
      size: "medium",
    }),
  ];

  return (
    <AppTable<IPackingLogByQR>
      loading={loading}
      data={result}
      columns={COLUMNS}
      onSearch={onSearch}
      searchPlaceholder={"Tìm kiếm: Mã lô"}
      onChangePage={onChangePage}
      hideHeader
      removeActionColumn
      defaultHeaderTable={210}
      onPageSizeChange={onPageSizeChange}
      hideSearch
    />
  );
};

export default PackingLog;
